import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        dark: window.localStorage.getItem('nm') != null ? (window.localStorage.getItem('nm') == 'true' ? true : false) : true,
        themes: {
            light: {
                primary: '#03A9F4',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#00897B',
                warning: '#C62828',
            },
            dark: {
                primary: '#1E88E5',
                secondary: '#272727',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#00897B',
                warning: '#C62828',
            },
        },
    },
});
